import Fetch from "../../utils/Fetch"

export default {
    namespaced: true,
    state: {
        freeTimeList: [],
        citiesList: [],
    },
    mutations: {
        setFreeTime(state, data) {
            if (!data) return
            state.freeTimeList = data
        },
        setCitiesList(state, data) {
            if (!data) return
            state.citiesList = data
        }
    },
    actions: {
        async loadFreeTime({commit}, {date, city}) {
            if (!date || !city) return
            if (typeof date === 'object') {
                date = date.toISOString()
            }
            let response = await Fetch(`forms/money-home/intervals/?date=${date}&city=${city}`)
            if (response.success) {
                commit('setFreeTime', response.data)
            }
        },
        async loadInitialData({commit}) {
            const response = await Fetch('forms/money-home/initials/')
            if (response.success) {
                commit('setCitiesList', response.data?.cities_select || [])
            }
            return {
                ...response
            }
        }
    },
    getters: {
        getFreeTime: state => state.freeTimeList,
        getCitiesList: state => state.citiesList,
    }
}